module.exports = __webpack_public_path__ + "img/main-logo.5f1b03b3.png";